import { useEffect, useState } from "react";
import { useWatch, Control, FieldValues } from "react-hook-form";

// 🧠 Shallow+Deep comparison utility for form data
function isDeepEqual(a: any, b: any): boolean {
  if (a === b) return true;

  if (typeof a !== typeof b) return false;

  if (a == null || b == null) return false;

  if (typeof a !== "object") return a === b;

  if (Array.isArray(a) !== Array.isArray(b)) return false;

  if (Array.isArray(a)) {
    if (a.length !== b.length) return false;
    return a.every((el, i) => isDeepEqual(el, b[i]));
  }

  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  if (keysA.length !== keysB.length) return false;

  for (const key of keysA) {
    if (!keysB.includes(key)) return false;
    if (!isDeepEqual(a[key], b[key])) return false;
  }

  return true;
}

export function useFormDirtyCheck<T extends FieldValues>(
  control: Control<T>,
  originalValues: T
): boolean {
  const watchedValues = useWatch({ control });
  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    const dirty = !isDeepEqual(watchedValues, originalValues);
    setIsDirty(dirty);
  }, [watchedValues, originalValues]);

  return isDirty;
}